import Em from 'ember';
export default Em.Mixin.create({
  relativeBoundingRectPosition($elementA, $elementB) {
    let $domElementA = $elementA[0];
    let $domElementB = $elementB[0];
    return {
      top: this.verticalDifferenceBetweenElements($domElementA, $domElementB),
      left: this.horizontalDifferenceBetweenElements($domElementA, $domElementB)
    };
  },
  verticalDifferenceBetweenElements($domElementA, $domElementB, options) {
    let boundingRectA = $domElementA.getBoundingClientRect();
    let boundingRectB = $domElementB.getBoundingClientRect();
    if (options && options.measureToBottomOfSecondBlock) {
      // Measure the distance from the bottom of element B to the top of element A
      return this._distanceBetweenTopValueAndBottomValue(boundingRectA, boundingRectB);
    } else {
      // Measure the distance from the top of element B to the top of element A
      return this._distanceBetweenTopValues(boundingRectA, boundingRectB);
    }
  },
  horizontalDifferenceBetweenElements($domElementA, $domElementB) {
    let boundingRectA = $domElementA.getBoundingClientRect();
    let boundingRectB = $domElementB.getBoundingClientRect();
    return this._distanceBetweenLeftValues(boundingRectA, boundingRectB);
  },
  _distanceBetweenTopValueAndBottomValue(boundingRectA, boundingRectB) {
    if (boundingRectA.top < 0 && boundingRectB.bottom >= 0) {
      return Math.abs(boundingRectB.bottom) + Math.abs(boundingRectA.top);
    } else if (boundingRectA.top < 0 && boundingRectB.bottom < 0) {
      return Math.abs(boundingRectA.top) - Math.abs(boundingRectB.bottom);
    } else {
      return Math.abs(boundingRectB.bottom) - Math.abs(boundingRectA.top);
    }
  },
  _distanceBetweenTopValues(boundingRectA, boundingRectB) {
    return this._distanceBetweenTwoPoints(boundingRectA.top, boundingRectB.top);
  },
  _distanceBetweenLeftValues(boundingRectA, boundingRectB) {
    return this._distanceBetweenTwoPoints(boundingRectA.left, boundingRectB.left);
  },
  _distanceBetweenTwoPoints(pointA, pointB) {
    let minPoint = Math.min(pointA, pointB);
    let maxPoint = Math.max(pointA, pointB);
    if (minPoint < 0 && maxPoint >= 0) {
      return Math.abs(maxPoint) + Math.abs(minPoint);
    } else if (minPoint < 0 && maxPoint < 0) {
      return Math.abs(Math.abs(minPoint) - Math.abs(maxPoint));
    } else {
      return Math.abs(Math.abs(maxPoint) - Math.abs(minPoint));
    }
  }
});